import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {clsx} from 'clsx'
import type {Block} from '@/_new-code/services/kontent-ai/types'
import {EnhancedCardBlock, type EnhancedCardContentItem} from '../enhanced-card'

export type PromotionCardGroupContentItem = IContentItem<{
	textAlignment: Elements.MultipleChoiceElement
	brandName: Elements.TextElement
	brandDescription: Elements.TextElement
	productPromotionCards: Elements.LinkedItemsElement<EnhancedCardContentItem>
}>

export const PromotionCardGroupBlock: Block<PromotionCardGroupContentItem> = ({
	block,
	...context
}) => {
	const getTextAlignment = (alignment: string | undefined): string => {
		switch (alignment) {
			case 'left':
				return 'text-left'
			case 'center':
				return 'text-center'
			case 'right':
				return 'text-right'
			default:
				return 'text-center'
		}
	}

	const textAlignment = getTextAlignment(
		block.elements.textAlignment[0]?.codename
	)
	return (
		<div className="my-4">
			<div className={clsx('px-4', textAlignment)}>
				<h2>{block.elements.brandName}</h2>
				<h4>{block.elements.brandDescription}</h4>
			</div>
			<div className="flex-wrap md:flex">
				{block.elements.productPromotionCards.map((card) => (
					<div
						className="flex justify-center p-4 md:w-1/3"
						key={card.system.id}
					>
						<EnhancedCardBlock block={card} {...context} />
					</div>
				))}
			</div>
		</div>
	)
}
